// One write at a time, with feedback while it runs: the submit button binds to
// isSaving (:disabled + is-loading), a notice stays up until the request settles, and a
// failure is toasted. Resolves true on success, so callers close their modal only then
// and a failed form keeps what was typed for a retry.
export default {
  data () {
    return {
      isSaving: false
    }
  },
  methods: {
    async runSave (action) {
      if (this.isSaving) {
        return false
      }
      this.isSaving = true
      const notice = this.$buefy.toast.open({ message: 'Submitting, please wait…', type: 'is-info', indefinite: true })
      try {
        await action()
        return true
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 5000, type: 'is-danger' })
        return false
      } finally {
        notice.close()
        this.isSaving = false
      }
    }
  }
}
